import { render } from "./PrivacyPolicy.vue?vue&type=template&id=4f61f0f7&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=4f61f0f7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f61f0f7"]])

export default __exports__